export default import.meta.ROLLDOWN_FILE_URL_VbxLJhAIc7PkPpTeTBakFw